import React from 'react';

import { scale360, spaceL } from '@xing-com/tokens';

import { MainPageContext } from '../../contexts/main-page-context';

import { Styled } from './article-block-wrapper.styles';

export const ArticleBlockWrapper: React.FC<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  const { isHandheld } = React.useContext(MainPageContext);

  return isHandheld ? (
    <Styled.Carousel
      itemMaxWidth={scale360}
      itemMinWidth={scale360}
      itemSpacing={spaceL}
      horizontalPadding={spaceL}
      itemSnapPosition="center"
    >
      {children}
    </Styled.Carousel>
  ) : (
    <Styled.GridContainer variant="FullSize">{children}</Styled.GridContainer>
  );
};
